import { Box, Container } from "@chakra-ui/react";
import { ContactInfo } from "../../components/contact/ContactInfo";

export const ContactSection = () => {
  return (
    <Box id="contact" py={20}>
      <Container maxW="container.xl">
        <ContactInfo />
      </Container>
    </Box>
  );
};
